export class AssetManager {

}